export class AssetManager {

}